import ApiService from "src/util/api.service";
import { getLanguageHeaders } from "src/services/commonLanguageHeader";
import { ServicesUrlEndpoints } from "src/services/servicesEndpointConstant";

export type RelayStatusTypeSortDirection = "ASC" | "DESC";

export interface RelayStatusTypeListParams {
  page?: number;
  size?: number;
  sort?: RelayStatusTypeSortDirection;
  sortBy?: string;
}

export interface RelayStatusTypeRecord {
  id: string | number;
  name?: string;
  code?: string;
  description?: string;
  active?: boolean | number | string;
  baseType?: boolean;
  usedForMapping?: boolean;
  createDate?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
  [key: string]: unknown;
}

export interface RelayStatusTypePayload {
  active: boolean;
  description?: string;
  name: string;
  code: string;
  usedForMapping: boolean;
  baseType: boolean;
  createDate?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
}

export interface RelayStatusTypeStatusPayload {
  id: string | number;
  active: boolean;
}

export interface RelayStatusTypePaginatedResponse {
  relayStatusTypes?: RelayStatusTypeRecord[];
  data?: RelayStatusTypeRecord[];
  items?: RelayStatusTypeRecord[];
  content?: RelayStatusTypeRecord[];
  totalItems?: number;
  totalElements?: number;
  total?: number;
}

const replaceId = (url: string, id: string | number) => url.replace("{id}", String(id));

export const getRelayStatusTypesList = (
  params: RelayStatusTypeListParams = {},
  language?: string,
) =>
  ApiService.get<{ response: RelayStatusTypePaginatedResponse }>(
    ServicesUrlEndpoints.ADMINISTRATION.SETUP.RELAY_STATUS_TYPES.LISTING,
    {
      params,
      ...getLanguageHeaders(language),
    }
  );

export const getRelayStatusTypeById = (id: string | number, language?: string) =>
  ApiService.get<{ response: RelayStatusTypeRecord }>(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.RELAY_STATUS_TYPES.GET, id),
    getLanguageHeaders(language)
  );

export const createRelayStatusType = (payload: RelayStatusTypePayload, language?: string) =>
  ApiService.post(
    ServicesUrlEndpoints.ADMINISTRATION.SETUP.RELAY_STATUS_TYPES.ADD,
    payload,
    getLanguageHeaders(language)
  );

export const updateRelayStatusType = (
  id: string | number,
  payload: RelayStatusTypePayload & { id: string | number },
  language?: string
) =>
  ApiService.patch(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.RELAY_STATUS_TYPES.UPDATE, id),
    payload,
    getLanguageHeaders(language)
  );

export const updateRelayStatusTypeStatus = (
  id: string | number,
  payload: RelayStatusTypeStatusPayload,
  language?: string
) =>
  ApiService.patch(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.RELAY_STATUS_TYPES.UPDATE, id),
    payload,
    getLanguageHeaders(language)
  );

export const deleteRelayStatusType = (id: string | number, language?: string) =>
  ApiService.delete(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.RELAY_STATUS_TYPES.DELETE, id),
    getLanguageHeaders(language)
  );
